const ServiceItems =
  [
    {
      id: 22,
      title: 'Website Design And Development',
      path: '/website-design-development',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },
    {
      id: 23,
      title: 'Web Application Development',
      path: '/web-application-development',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },
    {
      id: 24,
      title: 'Customize Application Development',
      path: '/customize-application-development',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },
    {
      id: 25,
      title: 'Domain & Web Hosting',
      path: '/web-hosting-services',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },

    {
      id: 26,
      title: 'Mobile Application Development',
      path: '/android-app-development',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },
    {
      id: 27,
      title: 'Bulk SMS',
      path: '/bulk-sms-services',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },



    {
      id: 28,
      title: 'Digital Marketing',
      path: '/digital-marketing-services',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },


    {
      id: 29,
      title: 'Data Analyst',
      path: '/data-analytics-services',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },
    {
      id: 30,
      title: 'SEO',
      path: '/seo-services',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    },
     {
      id: 31,
      title: 'Youtube & Insta Ads',
      path: '/youtube-instagram-ads',
      cName: 'drop_down_cont2',
      idName: 'drops2'
    }
  ]

export default ServiceItems;
